// ─────────────────────────────────────────────────────────────
// 🧪 B359 — MODO DE TESTE DE MODELO (migração para a geração 5.x)
// ─────────────────────────────────────────────────────────────
// Liga só NESTE navegador, pelo console. Três chaves independentes:
//   raciocínio (Opus, Fase 1):
//     localStorage.setItem("ia_modelo_teste", "claude-opus-5-5|medium")
//   verificador/transcrição/plano (classe Haiku, Fase 2 — AI_158):
//     localStorage.setItem("ia_modelo_teste_rapido", "claude-haiku-5-5")
//   leitor de PDF de exames (classe Sonnet, Fase 3 — AI_158):
//     localStorage.setItem("ia_modelo_teste_extracao", "claude-sonnet-5-5")
// Desliga: localStorage.removeItem(<chave>)
// O servidor aceita só valores de lista fechada e só de usuário médico; fora
// disso ignora e usa o padrão. Nunca lança (storage bloqueado = sem teste).

export interface ModoTesteIA {
  modelo?: string;
  esforco?: string;
  rapido?: string;
  extracao?: string;
}

/** Interpreta os valores crus das 3 chaves. Puro, testável. */
export function interpretarModoTeste(
  raciocinio: string | null | undefined,
  rapido: string | null | undefined,
  extracao: string | null | undefined
): ModoTesteIA | null {
  const out: ModoTesteIA = {};
  if (raciocinio) {
    const [modelo, esforco] = raciocinio.split("|").map((x) => x.trim());
    if (modelo && esforco) {
      out.modelo = modelo;
      out.esforco = esforco;
    }
  }
  const r = (rapido || "").trim();
  if (r) out.rapido = r;
  const e = (extracao || "").trim();
  if (e) out.extracao = e;
  return Object.keys(out).length > 0 ? out : null;
}

/** Lê as chaves do localStorage deste navegador. Nunca lança. */
export function lerModoTesteIA(): ModoTesteIA | null {
  try {
    const ls = window.localStorage;
    return interpretarModoTeste(
      ls.getItem("ia_modelo_teste"),
      ls.getItem("ia_modelo_teste_rapido"),
      ls.getItem("ia_modelo_teste_extracao")
    );
  } catch {
    return null;
  }
}

/** Texto curto para o log do console (sem segredo, sem dado de paciente). */
export function descreverModoTeste(t: ModoTesteIA): string {
  const partes: string[] = [];
  if (t.modelo) partes.push(`${t.modelo} · esforço ${t.esforco}`);
  if (t.rapido) partes.push(`rápido ${t.rapido}`);
  if (t.extracao) partes.push(`extração ${t.extracao}`);
  return partes.join(" · ");
}
